import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { Constant } from '../../../../../infrastructure/common';
import { MenuService, TokenService, AuthenticationService, CssConfigService } from '../../../../../infrastructure/services/base';
import { ConfirmationService } from 'primeng/primeng';

declare var jQuery: any;

@Component({
    //selector: 'app-login',
    moduleId: module.id,
    templateUrl: './login.html',
    styleUrls : ['./login.css']
  })
export class LoginComponent implements OnInit, AfterViewInit {
    @ViewChild('username') username;
    @ViewChild('btnSubmit') btnSubmit: ElementRef;
    @ViewChild('myModal') myModal!: ElementRef;

    model: any = {};
    isLoading = false;
    returnUrl: string;
    divMessage: string = '';
    ownerCode : string = '';
    currentYear: number = new Date().getFullYear();
    showpassword : boolean = false;

    constructor(
		private menuService: MenuService,
    private confirmationService : ConfirmationService,
    private cssService : CssConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService) { }

    ngAfterViewInit() {
        // reset login status
        // this.authenticationService.logout();

        // console.log(this.username);
        // setTimeout(() => {
        //     this.username.focus();
        // },150);
        //this.username.nativeElement.focus();
        jQuery('input[name=txtUserName]').focus();
    }

    togglePasswordVisibility() {
      this.showpassword = !this.showpassword;
    }

    focusPassword(event: any) {
        //event.stopPropagation();
        jQuery('input[name=txtPassword]').focus();
    }
    focusButtonSubmit() {
        this.btnSubmit.nativeElement.click()
    }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        this.setCssProperty();
    }

    setCssProperty(){
      this.ownerCode = localStorage.getItem('OwnerCode');
      this.cssService.getCssConfig(this.ownerCode).subscribe(data => {
        data.Result.forEach(e => {
          // console.log(e);
          this.changeCssProperty(e.CssClass, (e.CssValue == null ? e.DefaultCssValue : e.CssValue));
        })
      })
    }

    changeCssProperty(paramName: string, value: string): void {
      // Access the :root element
      const root = document.documentElement;
      root.style.setProperty(paramName, value);
    }

    login() {
        this.isLoading = true;
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
            data => {
                // login successful if there's a jwt token in the response
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        var token = message.Result;

                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        TokenService.setToken(token);

                        // this.router.navigate([this.returnUrl]);
                        this.menuService.getDefaultWelcomeScreen(Constant.defaultModuleId).subscribe(defaultScreen => {
                          this.closeModal();
                          if(defaultScreen == null) {
                            this.router.navigate(['/pages']);
                          }
                          else
                          {
                            this.router.navigate([defaultScreen]);
                          }
                        });
                    }
                    else {
                        // alert('Error: (' + message.MessageNumber + ') ' + message.Message + '\n' + message.AdditionalInformation);
                        this.divMessage = "Error: (" + message.MessageNumber + ") " + message.Message + "--" + message.AdditionalInformation;
                        this.isLoading = false;
                    }
                }
                else {
                    this.showMessage('Error', '', 'Unknown error occured.');
                    this.isLoading = false;
                }

                // if (user && user.tokenId) {
                //     // store user details and jwt token in local storage to keep user logged in between page refreshes
                //     // localStorage.setItem('currentUser', JSON.stringify(user));
                //     //alert(JSON.stringify(user));
                // }
            },
            error => {
                // this.alertService.error(error);
                // var err = error.json();

                // alert('Error: (' + error.status + ') ' + error.statusText + '\n' + error._body);
                this.showMessage('Error', error.status, error.statusText, error._body);
                // alert(JSON.stringify(error));
                this.isLoading = false;
            });
    }

truncateString(str, num) {
      if(str!=null){
        return str.length > num ? str.slice(0, num) + '...' : str;
      } else {
        return ''
      }
    }

    closeModal() {
      const modalElement = this.myModal.nativeElement;
      if (modalElement) {
        // Use Bootstrap's JavaScript API to hide the modal
        (window as any).$(`#myModal`).modal('hide'); // Requires jQuery
      }
    }

    showMessage(messageType: string, messageNumber: string, message: string, additionalInfo: string = null) {
      // jQuery('#PopupMessageTitle').html(title);		    //jQuery('#PopupMessageTitle').html(title);
      // jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));		    //jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
      // jQuery('#PopupMessage').modal('show');		    //jQuery('#PopupMessage').modal('show');
      // var icon = 'fa fa-check-circle';
      // if (title.indexOf('Error') < 0) icon = 'fa fa-times-circle';

      // let icon = Constant.MessageIcon.error;
      // if (messageType == Constant.MessageType.success) {
      //   icon = Constant.MessageIcon.success;
      // }

      // this.confirmationService.confirm({
      //   rejectVisible: false,
      //   icon: icon,
      //   header: messageType,
      //   message: '(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''),
        // accept: () => {
        //   //what next??
        //   alert('test');
        // }
      // });

      let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);

      jQuery('#PopupMessageTitle').html(messageType);
      jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
      jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/login/login.component.ts